var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 128,
    viewBox: "0 0 217 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 128,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 57.1621V100",
    stroke: "#2991FF",
    strokeWidth: 4.82682,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9062 74.2568L33.9063 99.9999",
    stroke: "#9FCDFF",
    strokeWidth: 4.82682,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8125 57.1621V100",
    stroke: "#2991FF",
    strokeWidth: 4.82682,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7188 78.2793L71.7188 100",
    stroke: "#9FCDFF",
    strokeWidth: 4.82682,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6172 67.0166L90.6172 99.9998",
    stroke: "#2991FF",
    strokeWidth: 4.82682,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.523 71.8438L109.523 100",
    stroke: "#9FCDFF",
    strokeWidth: 4.82682,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.43 67.8213L128.43 100",
    stroke: "#2991FF",
    strokeWidth: 4.82682,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.336 57.7656L147.336 100",
    stroke: "#9FCDFF",
    strokeWidth: 4.82682,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M166.242 35.2402L166.242 100",
    stroke: "#2991FF",
    strokeWidth: 4.82682,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.227 29.1858C153.732 23.7729 161.199 20.7324 168.984 20.7324V49.5935L148.227 29.1858Z",
    fill: "#EDF6FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.742 49.4415C135.742 40.3222 139.388 31.5761 145.879 25.127L170.35 49.4415H135.742Z",
    fill: "#DAECFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.927 74.4814C134.421 65.8173 131.615 54.913 133.125 44.167L173.512 49.843L140.927 74.4814Z",
    fill: "#C6E2FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.904 88.1677C175.417 94.0489 158.915 91.7455 146.618 82.1223C140.577 77.3932 135.886 71.1488 133.02 64.0217L173.575 47.5584L189.904 88.1677Z",
    fill: "#9FCDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.586 80.7497C189.548 91.8242 173.459 96.1515 158.379 92.0983C150.97 90.1056 144.212 86.1905 138.789 80.7497L169.688 49.749L200.586 80.7497Z",
    fill: "#2991FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.75 5C184.667 5 199.376 13.5133 207.336 27.333C215.295 41.1526 215.295 58.1793 207.336 71.9989C205.389 75.3801 203.007 78.4889 200.254 81.2492L168.75 49.666V5Z",
    fill: "#006ADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.c80c0b41a67c1be2ce17d86cda548401.svg";
export { ForwardRef as ReactComponent };